const Moment = require('moment-timezone');
const extendMoment = require('moment-range').extendMoment;
const moment = extendMoment(Moment);
moment.tz.setDefault("Europe/Paris");
moment.locale('fr');

const priceArr = [{r: 19.90, n: 10, f: 4.68, h: 5.22}, {r: 23.90, n: 12, f: 5.64, h: 6.26},
                  {r: 39.80, n: 20, f: 9.36, h: 10.44}, {r: 160, n: 80, f: 37.44, h: 42.56}];

const publicHolidays = (year) => {
  var labourDay = new Date(year, "04", "01");
	var newYear = new Date(year, "00", "01");
	var victoryWW2 = new Date(year, "04", "08");
	var nationalDay = new Date(year,"06", "14");
	var assomption = new Date(year, "07", "15");
	var allSaint = new Date(year, "10", "01");
	var armistice = new Date(year, "10", "11");
	var xmas = new Date(year, "11", "25");

	var G = year % 19
	var C = Math.floor(year/100)
	var H = (C - Math.floor(C/4) - Math.floor((8*C+13)/25) + 19*G + 15)%30
	var I = H - Math.floor(H/28)*(1 - Math.floor(H/28)*Math.floor(29/(H + 1))*Math.floor((21 - G)/11))
	var J = (Number(year) * 1 + Math.floor(year/4) + I + 2 - C + Math.floor(C/4))%7
	var L = I - J
	var easterMonth = 3 + Math.floor((L + 40)/44)
	var easterDay = L + 28 - 31*Math.floor(easterMonth/4)
	var easter = new Date(year, easterMonth-1, easterDay)
	var easterMonday = new Date(year, easterMonth-1, easterDay+1)
	var ascension = new Date(year, easterMonth-1, easterDay+39)
	var whit = new Date(year, easterMonth-1, easterDay+49)
	var whitMonday = new Date(year, easterMonth-1, easterDay+50)

	return (new Array(labourDay, newYear, victoryWW2, nationalDay, assomption, allSaint, armistice, xmas, easter, easterMonday, ascension, whitMonday, whit))
}

const hasForfait = (date, duration) => {
  let timeNb = moment(date).hours() + (moment(date).minutes() / 60);
  if (timeNb <= 20 && timeNb + duration >= 32) {
    return (true);
  }
  return (false);
}

const calculateRate = (date) => {
  let newDate = moment(date);
  let holidays = publicHolidays(newDate.year());
  for (let i = 0; i < holidays.length; i++) {
    if (moment(holidays[i]).diff(moment(date), 'days') === 0) {
      return (i === 0 ? priceArr[2] : priceArr[1]);
    }
  }
  //console.log("day of date->", newDate.weekday());
  return (newDate.weekday() === 6 ? priceArr[1] : priceArr[0]);
}

const calculateOverNight = (forfait, startTime, rateDay, rateDayAfter, duration) => {
  let clock = (forfait) ? duration - 12 : duration;
  let money = (forfait) ? priceArr[3] : {r: 0, n: 0, f: 0, h: 0};
  //console.log("calculate over night data=", clock, money.r, rateDay.r, startTime);
  if (clock > 0 && startTime < 24) {
    clock = clock - (20 - startTime);
    money.r = (money.r + rateDay.r * (20 - startTime));
    money.n = (money.n + rateDay.n * (20 - startTime));
    money.f = (money.f + rateDay.f * (20 - startTime));
    money.h = (money.h + rateDay.h * (20 - startTime));
  }
  if (clock > 0) {
    money.r = (money.r + rateDayAfter.r * clock);
    money.n = (money.n + rateDayAfter.n * clock);
    money.f = (money.f + rateDayAfter.f * clock);
    money.h = (money.h + rateDayAfter.h * clock);
  }
  //console.log("overNight money->", money);
  return (money);
}

const getRate = (startDate, endDate) => {
  let duration = moment.duration(moment(endDate).diff(moment(startDate))).asHours();
  let forfait = hasForfait(startDate, duration);
  let numberOfDays = moment(startDate).diff(moment(endDate), 'days');
  let rateDay = calculateRate(startDate);
  let rateDayAfter = calculateRate(endDate);
  console.log("calculate debit variables->\n", forfait, numberOfDays, duration, rateDay, rateDayAfter, moment(startDate).format());
  if (forfait || moment(startDate).diff(moment(endDate), 'days') > 0) {
    return (calculateOverNight(forfait, moment(startDate).hours(), rateDay, rateDayAfter, duration));
  } else {
    return ({
      r: rateDay.r * duration,
      n: rateDay.n * duration,
      f: rateDay.f * duration,
      h: rateDay.h * duration,
    });
  }
}

module.exports = {
  getRate,
};



// WEBPACK FOOTER //
// ./src/utils/calculateRateAndPrice.js